<template>
  <div class="bg-white min-h-screen flex flex-col lg:relative">
    <div class="flex-grow flex flex-col">
      <main class="flex-grow flex justify-center flex-col bg-white">
        <div
          class="flex-grow mx-auto w-full flex justify-center flex-col px-4 sm:px-6 lg:px-8"
        >
          <div class="flex-shrink-0 justify-center pt-16 grid sm:grid-cols-6" v-if="!satisfied">
            <div class="hero container max-w-screen-lg mx-auto pb-10 flex justify-center col-start-1 col-end-4">
              <img
                class="h-32 w-auto mx-auto"
                src="../assets/encom_official_2.png"
                alt=""
              />
            </div>
            <h2
              class="mt-10 mb-5 text-center font-extrabold encom_primary_text tracking-tight text-5xl col-start-1 col-end-4"
            >
              Merci &#128591;
            </h2>
            <span class="mt-10 text-center text-2xl text-gray-500 col-start-1 col-end-4">
              {{ this.text }}
            </span>
          </div>

          <div class="flex-shrink-0 justify-center pt-16 grid sm:grid-cols-6" v-else>
            <div class="hero container max-w-screen-lg mx-auto pb-10 flex justify-center col-start-1 col-end-4">
              <img
                class="h-20 w-auto mx-auto"
                src="../assets/encom_official_2.png"
                alt=""
              />
            </div>
            <h2
              class="mt-10 mb-5 text-center font-extrabold black tracking-tight text-3xl col-start-1 col-end-4"
            >
              <span class="mr-2">🎉</span>
              Merci beaucoup pour votre retour positif !
            </h2>
            <div class="mt-10 mx-auto text-justify text-2xl col-start-1 col-end-4">
              Si vous avez <strong>30 secondes de plus, quelques mots</strong> sur<br>
              Google feraient vraiment une différence pour nous. Même<br>
              une phrase courte suffit - et ça nous aide énormément à<br>
              faire connaître la qualité de notre service.
            </div>

            <div class="mt-10 mb-5 text-center text-l italic col-start-1 col-end-4">
              ✍️ D’autres clients ont dits : “Une équipe à l’écoute”, “Un déploiement<br>
              efficace”, “Equipe pro et réactive”
            </div>

            <a
              href="https://g.page/r/CdFlcRhPCPunEAE/review"
              class="google_blue text-2xl font-medium inline-flex items-center mx-auto col-start-1 col-end-4 py-1 pl-1 pr-2"
            >
              <img src="../assets/google_icon.svg" alt="Google Logo" class="bg-white h-12 w-12 p-1 mr-2">

              <span class="text-white font-light">Donner mon avis sur Google (30 sec)</span>
            </a>

            <div class="mt-7 mb-5 mx-auto text-center text-xl col-start-1 col-end-4">
              Merci encore pour votre soutien ❤️<br>
              <strong>L'équipe Encom</strong>
            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="hidden lg:block lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
      <img
        class="absolute inset-0 h-full w-full object-cover"
        src="../assets/Image_Fond_Encom_Enquete.jpg"
        alt=""
        v-if="!satisfied"
      />
      <img
        class="absolute inset-0 h-full w-full object-cover"
        src="../assets/repas.jpg"
        alt=""
        v-else
      />

      <div class="absolute top-4 right-4 py-2 px-3 bg-black bg-opacity-50" v-if="satisfied">
        <div class="flex items-center">
          <span class="text-2xl mr-3">📷</span>
          <span class="text-white text-sm font-bold text-center">
            Une partie de votre équipe Encom<br>
            lors d’un déjeuner d’été
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SurveyCompleted",
  props: ["text", "satisfied"],
};
</script>

<style></style>
